// @ts-strict-ignore
import React from 'react'
import RichTextBlock from '../../ev-rich-text-block'
import { removeWhitespaceAndSpecialChars } from '../../helpers/commons'
import { getValue } from '../../../utils/product-schema'
import { Button, Image } from '../../../atoms'
import classNames from 'classnames'

const AboveTheFold = (props) => {
  const {
    data,
    name,
    displayInfo,
    title,
    border = false,
    datasetId,
    schemaId,
    tableId,
    horizontal,
    linkOutCard,
    sys,
  } = props

  try {
    return (
      <div
        className={classNames(
          'above-the-fold',
          { 'above-the-fold--horizontal': horizontal },
          { 'above-the-fold--link-out-card': linkOutCard },
        )}
        id={removeWhitespaceAndSpecialChars(name)}
        data-fs-core-product-table
        data-dataset-id={datasetId}
        data-schema-id={schemaId}
        data-contentful-table-id={tableId}
        data-contentful-name={name}
      >
        {title && <h2 className='above-the-fold__heading'>{title}</h2>}
        <div className='above-the-fold__container'>
          {data.map((d, i) => {
            const product = displayInfo[i]?.product || displayInfo.product
            const header = displayInfo[i]?.header || displayInfo.header
            const highlight = displayInfo[i]?.highlight || displayInfo.highlight
            const ctaText = getValue(product.ctaText, d)
            const ctaLink = getValue(product.ctaLink, d)
            const trackingObject = {
              component_category: 'product table',
              component_id: sys?.id,
              component_name: 'productTable',
              contentful_name: name,
              contentful_variant: 'aboveTheFold',
              additionalProps: { text: ctaText, url: ctaLink, index: i },
            }
            return ctaLink ? (
              <div
                className={classNames('above-the-fold__card', {
                  'above-the-fold__card--border': border,
                  'above-the-fold__card--highlight': highlight,
                })}
                key={i}
              >
                <div className='above-the-fold__card__img-cta'>
                  <div className='above-the-fold__card__img-wrapper'>
                    <Image
                      src={getValue(product.image, d)}
                      alt={`${getValue(product.name, d)} logo`}
                    />
                  </div>

                  {horizontal && getValue(header?.title, d) && (
                    <div
                      className={classNames('above-the-fold__card__title', {
                        'above-the-fold__card__title--highlight': highlight,
                      })}
                    >
                      {getValue(header.title, d)}
                    </div>
                  )}

                  <Button
                    href={ctaLink}
                    size='sm'
                    variant={highlight ? 'tertiary' : 'primary'}
                    openInNewTab={true}
                    position={i}
                    withIcon={horizontal}
                    dataClickTracking={trackingObject}
                  >
                    {horizontal ? (
                      <span className='atf-button-horizontal-text'>{ctaText}</span>
                    ) : (
                      ctaText
                    )}
                  </Button>
                </div>
                <div className='above-the-fold__card__text-wrapper'>
                  {getValue(header?.title, d) && (
                    <div
                      className={classNames('above-the-fold__card__title', {
                        'above-the-fold__card__title--highlight': highlight,
                      })}
                    >
                      {getValue(header.title, d)}
                    </div>
                  )}
                  <div
                    className={classNames('above-the-fold__card__name', {
                      'above-the-fold__card__name--highlight': highlight,
                    })}
                  >
                    {getValue(product.name, d)}
                  </div>
                  <div
                    className={classNames('above-the-fold__card__usp', {
                      'above-the-fold__card__usp--highlight': highlight,
                    })}
                  >
                    {getValue(product.usp, d)}
                  </div>
                  <div className='above-the-fold__card__button'>
                    <Button
                      href={ctaLink}
                      size='sm'
                      variant={highlight ? 'tertiary' : 'primary'}
                      openInNewTab={true}
                      position={i}
                      withIcon={horizontal}
                      dataClickTracking={trackingObject}
                    >
                      {horizontal ? (
                        <span className={'atf-button-horizontal-text'}>{ctaText}</span>
                      ) : (
                        ctaText
                      )}
                    </Button>
                  </div>
                </div>
              </div>
            ) : (
              <div />
            )
          })}
          {linkOutCard && (
            <div
              className={classNames('above-the-fold__card link-out-card', {
                'above-the-fold__card--border': border,
              })}
            >
              <RichTextBlock {...linkOutCard.fields.content} />
            </div>
          )}
        </div>
      </div>
    )
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log(JSON.stringify(`ABOVE THE FOLD MISSING: ${e}`))
  }
}

export default AboveTheFold
